export default __webpack_public_path__ + "static/media/Kasbokar.db7886ef.png";